// Technical
import Block, { BlockStyles } from "./technical/Block.jsx";
import BlockGridColumn, { BlockGridColumnStyles } from "./technical/BlockGridColumn.jsx";
import BlockGridRow, { BlockGridRowStyles } from "./technical/BlockGridRow.jsx";
import BlockProject, { BlockProjectStyles } from "./technical/BlockProject.jsx";

// Blocks
import BlockSteps, { BlockStepsStyles } from "./project/BlockSteps.jsx";
import BlockFeatures, { BlockFeaturesStyles } from "./project/BlockFeatures.jsx";
import BlockFeedbacks, { BlockFeedbacksStyles } from "./project/BlockFeedbacks.jsx";
import BlockProductDescription, { BlockProductDescriptionStyles } from "./project/BlockProductDescription.jsx";
import BlockFooter, { BlockFooterStyles } from "./project/BlockFooter.jsx";
import BlockHeader, { BlockHeaderStyles } from "./project/BlockHeader.jsx";
import BlockHeaderButtons, { BlockHeaderButtonsStyles } from "./project/BlockHeaderButtons.jsx";
import BlockHeaderEcommerceButtons, {
    BlockHeaderEcommerceButtonsStyles,
} from "./project/BlockHeaderECommerceButtons.jsx";
import BlockHeaderContent, { BlockHeaderContentStyles } from "./project/BlockHeaderContent.jsx";
import BlockHeaderImageHorizontal, { BlockHeaderImageHorizontalStyles } from "./project/BlockHeaderImageHorizontal.jsx";
import BlockHeaderImageVertical, { BlockHeaderImageVerticalStyles } from "./project/BlockHeaderImageVertical.jsx";
import BlockHeaderECommerce, { BlockHeaderECommerceStyles } from "./project/BlockHeaderECommerce.jsx";

import BlockEmbed, { BlockEmbedStyles } from "./project/BlockEmbed.jsx";
import BlockVideo, { BlockVideoStyles } from "./project/BlockVideo.jsx";

// import BlockHeaderLogotype, { BlockHeaderLogotypeStyles } from "./project/BlockHeaderLogotype.jsx"; //
// import BlockLogotypes, { BlockLogotypesStyles } from "./project/BlockLogotypes.jsx"; //
import BlockMenu, { BlockMenuStyles } from "./project/BlockMenu.jsx";
import BlockNumbers, { BlockNumbersStyles } from "./project/BlockNumbers.jsx";
import BlockSlider, { BlockSliderStyles } from "./project/BlockSlider.jsx";
import BlockECommerceSlider, { BlockECommerceSliderStyles } from "./project/BlockECommerceSlider.jsx";
import BlockOffers, { BlockOffersStyles } from "./project/BlockOffers.jsx";
// import Grider, { GriderStyles } from "./project/Grider.jsx"; //
import BlockDelivery, { BlockDeliveryStyles } from "./project/BlockDelivery.jsx";
import BlockECommerce, { BlockECommerceStyles } from "./project/BlockECommerce.jsx";
import BlockGetInTouch, { BlockGetInTouchStyles } from "./project/BlockGetInTouch.jsx";

// Elements
import BurgerMenu, { BurgerMenuStyles } from "./project/BurgerMenu.jsx";
// import Button, { ButtonStyles } from "./project/Button.jsx"; //
import CookiesPopup, { CookiesPopupStyles } from "./project/CookiesPopup.jsx";
import Copyright, { CopyrightStyles } from "./project/Copyright.jsx";
// import Counter, { CounterStyles } from "./project/Counter.jsx"; //
// import DigitalDistribution, { DigitalDistributionStyles } from "./project/DigitalDistribution.jsx"; //
// import Feature, { FeatureStyles } from "./project/Feature.jsx"; //
import Header1, { Header1Styles } from "./project/Header1.jsx";
import HeaderEvent, { HeaderEventStyles } from "./project/HeaderEvent.jsx";
// import Header2, { Header2Styles } from "./project/Header2.jsx"; //
// import Header3, { Header3Styles } from "./project/Header3.jsx"; //
// import Image, { ImageStyles } from "./project/Image.jsx"; //
// import Link, { LinkStyles } from "./project/Link.jsx"; //
import Logotype, { LogotypeStyles } from "./project/Logotype.jsx";
import MenuActions, { MenuActionsStyles } from "./project/MenuActions.jsx";
import MenuLinks, { MenuLinksStyles } from "./project/MenuLinks.jsx";
import OffersSellingPlans, { OffersSellingPlansStyles } from "./project/OffersSellingPlans.jsx";
import OffersTrafficAcquisition, { OffersTrafficAcquisitionStyles } from "./project/OffersTrafficAcquisition.jsx";
import PaymentLogos, { PaymentLogosStyles } from "./project/PaymentLogos.jsx";
// import Plan, { PlanStyles } from "./project/Plan.jsx"; //
// import Quotation, { QuotationStyles } from "./project/Quotation.jsx"; //
import Socials, { SocialsStyles } from "./project/Socials.jsx";
// import Subscribe, { SubscribeStyles } from "./project/Subscribe.jsx"; //
import TermsOfUse, { TermsOfUseStyles } from "./project/TermsOfUse.jsx";
// import Text, { TextStyles } from "./project/Text.jsx"; //
import Timer, { TimerStyles } from "./project/Timer.jsx";

const GROUPS = {
    Technical: [
        { Component: Block, Styles: BlockStyles },
        { Component: BlockGridColumn, Styles: BlockGridColumnStyles },
        { Component: BlockGridRow, Styles: BlockGridRowStyles },
        { Component: BlockProject, Styles: BlockProjectStyles },
    ],

    Blocks: [
        { Component: BlockSteps, Styles: BlockStepsStyles },
        { Component: BlockFeatures, Styles: BlockFeaturesStyles },
        { Component: BlockFeedbacks, Styles: BlockFeedbacksStyles },
        { Component: BlockProductDescription, Styles: BlockProductDescriptionStyles },
        { Component: BlockFooter, Styles: BlockFooterStyles },
        { Component: BlockECommerce, Styles: BlockECommerceStyles },
        { Component: BlockGetInTouch, Styles: BlockGetInTouchStyles },
        { Component: BlockDelivery, Styles: BlockDeliveryStyles },
        { Component: BlockHeader, Styles: BlockHeaderStyles },
        { Component: BlockHeaderButtons, Styles: BlockHeaderButtonsStyles },
        { Component: BlockHeaderEcommerceButtons, Styles: BlockHeaderEcommerceButtonsStyles },
        { Component: BlockHeaderContent, Styles: BlockHeaderContentStyles },
        { Component: BlockHeaderImageHorizontal, Styles: BlockHeaderImageHorizontalStyles },
        { Component: BlockHeaderImageVertical, Styles: BlockHeaderImageVerticalStyles },
        { Component: BlockHeaderECommerce, Styles: BlockHeaderECommerceStyles },

        { Component: BlockEmbed, Styles: BlockEmbedStyles },
        { Component: BlockVideo, Styles: BlockVideoStyles },

        // { Component: BlockHeaderLogotype, Styles: BlockHeaderLogotypeStyles }, //
        // { Component: BlockLogotypes, Styles: BlockLogotypesStyles }, //
        { Component: BlockMenu, Styles: BlockMenuStyles },
        { Component: BlockNumbers, Styles: BlockNumbersStyles },
        { Component: BlockSlider, Styles: BlockSliderStyles },
        { Component: BlockECommerceSlider, Styles: BlockECommerceSliderStyles },
        { Component: BlockOffers, Styles: BlockOffersStyles },
        // { Component: Grider, Styles: GriderStyles }, //
    ],

    Elements: [
        { Component: BurgerMenu, Styles: BurgerMenuStyles },
        // { Component: Button, Styles: ButtonStyles }, //
        { Component: CookiesPopup, Styles: CookiesPopupStyles },
        { Component: Copyright, Styles: CopyrightStyles },
        // { Component: Counter, Styles: CounterStyles }, //
        // { Component: DigitalDistribution, Styles: DigitalDistributionStyles }, //
        // { Component: Feature, Styles: FeatureStyles }, //
        { Component: Header1, Styles: Header1Styles },
        { Component: HeaderEvent, Styles: HeaderEventStyles },
        // { Component: Header2, Styles: Header2Styles }, //
        // { Component: Header3, Styles: Header3Styles }, //
        // { Component: Image, Styles: ImageStyles }, //
        // { Component: Link, Styles: LinkStyles }, //
        { Component: Logotype, Styles: LogotypeStyles },
        { Component: MenuActions, Styles: MenuActionsStyles },
        { Component: MenuLinks, Styles: MenuLinksStyles },
        { Component: OffersSellingPlans, Styles: OffersSellingPlansStyles },
        { Component: OffersTrafficAcquisition, Styles: OffersTrafficAcquisitionStyles },
        { Component: PaymentLogos, Styles: PaymentLogosStyles },
        // { Component: Plan, Styles: PlanStyles }, //
        // { Component: Quotation, Styles: QuotationStyles }, //
        { Component: Socials, Styles: SocialsStyles },
        // { Component: Subscribe, Styles: SubscribeStyles }, //
        { Component: TermsOfUse, Styles: TermsOfUseStyles },
        // { Component: Text, Styles: TextStyles }, //
        { Component: Timer, Styles: TimerStyles },
    ],
};

const STYLES = {
    BlockFeaturesStyles,
    BlockFeedbacksStyles,
    BlockProductDescriptionStyles,
    BlockFooterStyles,
    BlockECommerceStyles,
    BlockGetInTouchStyles,
    BlockDeliveryStyles,
    BlockGridColumnStyles,
    BlockGridRowStyles,
    BlockHeaderButtonsStyles,
    BlockHeaderEcommerceButtonsStyles,
    BlockHeaderContentStyles,
    BlockHeaderImageHorizontalStyles,
    BlockHeaderImageVerticalStyles,
    BlockHeaderECommerceStyles,

    BlockEmbedStyles,
    BlockVideoStyles,

    BlockHeaderStyles,
    BlockMenuStyles,
    BlockNumbersStyles,
    BlockSliderStyles,
    BlockECommerceSliderStyles,
    BlockOffersStyles,
    BlockProjectStyles,
    BlockStepsStyles,
    BlockStyles,
    BurgerMenuStyles,
    CookiesPopupStyles,
    CopyrightStyles,
    Header1Styles,
    HeaderEventStyles,
    LogotypeStyles,
    MenuActionsStyles,
    MenuLinksStyles,
    OffersSellingPlansStyles,
    OffersTrafficAcquisitionStyles,
    PaymentLogosStyles,
    SocialsStyles,
    TermsOfUseStyles,
    TimerStyles,
};

const ELEMENTS = {
    Block,
    BlockFeatures,
    BlockFeedbacks,
    BlockProductDescription,
    BlockFooter,
    BlockECommerce,
    BlockGetInTouch,
    BlockDelivery,
    BlockGridColumn,
    BlockGridRow,
    BlockHeader,
    BlockHeaderButtons,
    BlockHeaderEcommerceButtons,
    BlockHeaderContent,
    BlockHeaderImageHorizontal,
    BlockHeaderImageVertical,
    BlockHeaderECommerce,

    BlockEmbed,
    BlockVideo,

    BlockMenu,
    BlockNumbers,
    BlockSlider,
    BlockECommerceSlider,
    BlockOffers,
    BlockProject,
    BlockSteps,
    BurgerMenu,
    CookiesPopup,
    Copyright,
    Header1,
    HeaderEvent,
    Logotype,
    MenuActions,
    MenuLinks,
    OffersSellingPlans,
    OffersTrafficAcquisition,
    PaymentLogos,
    Socials,
    TermsOfUse,
    Timer,
};

const ELEMENT_NAMES_BY_GROUP = {
    Technical: [
        //
        "Block",
        "BlockGridColumn",
        "BlockGridRow",
        "BlockProject",
    ],

    Blocks: [
        "BlockSteps",
        "BlockFeatures",
        "BlockFeedbacks",
        "BlockProductDescription",
        "BlockFooter",
        "BlockECommerce",
        "BlockGetInTouch",
        "BlockDelivery",
        "BlockHeader",
        "BlockHeaderButtons",
        "BlockHeaderEcommerceButtons",
        "BlockHeaderContent",
        "BlockHeaderImageHorizontal",
        "BlockHeaderImageVertical",

        "BlockEmbed",
        "BlockVideo",

        // 'BlockHeaderLogotype', //
        // 'BlockLogotypes', //
        "BlockMenu",
        "BlockNumbers",
        "BlockSlider",
        // "BlockECommerceSlider",
        "BlockOffers",
        // 'Grider', //
    ],

    Elements: [
        "BurgerMenu",
        // 'Button', //
        "CookiesPopup",
        "Copyright",
        // 'Counter', //
        // 'DigitalDistribution', //
        // 'Feature', //
        "Header1",
        "HeaderEvent",
        // 'Header2', //
        // 'Header3', //
        // 'Image', //
        // 'Link', //
        "Logotype",
        "MenuActions",
        "MenuLinks",
        "OffersSellingPlans",
        "OffersTrafficAcquisition",
        "PaymentLogos",
        // 'Plan', //
        // 'Quotation', //
        "Socials",
        // 'Subscribe', //
        "TermsOfUse",
        // 'Text', //
        "Timer",
    ],
};

export default ELEMENTS;
export { STYLES as Styles, ELEMENT_NAMES_BY_GROUP };
